import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getSupporters } from "../lib/api";
import { Reveal } from "../components/Motion";

export default function SupportersPage() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    document.title = "Supporters — Motion & Meaning";
    getSupporters().then(setItems).catch(() => {});
  }, []);

  return (
    <div className="pt-32 md:pt-44 pb-32 min-h-screen" data-testid="supporters-page">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <Reveal>
          <p className="font-mono text-[11px] tracking-[0.4em] text-gold mb-6">RECOGNITION</p>
          <h1 className="font-serif text-5xl sm:text-7xl lg:text-8xl font-light leading-none text-white">
            THE PEOPLE WHO<br />MAKE THIS <span className="italic text-gold">EXIST.</span>
          </h1>
          <p className="text-white/55 max-w-xl mt-8 leading-relaxed">
            Motion & Meaning is carried by the people who choose to own the music. These supporters
            chose to be recognized. This is gratitude, not a customer list.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-x-10 gap-y-8 mt-20">
          {items.map((s, i) => (
            <Reveal key={`${s.displayName}-${i}`} delay={(i % 6) * 0.05}>
              <div className="border-t border-white/10 pt-6" data-testid={`supporter-card-${i}`}>
                <p className="font-serif text-2xl font-light text-white">{s.displayName}</p>
                <p className="font-mono text-[9px] tracking-[0.3em] text-gold mt-2">{(s.designation || "SUPPORTER").toUpperCase()}</p>
                {s.link && s.handle && (
                  <a href={s.link} target="_blank" rel="noreferrer" className="font-mono text-[10px] text-white/40 hover:text-gold transition-colors mt-2 inline-block">
                    {s.platform && `${s.platform} · `}{s.handle}
                  </a>
                )}
              </div>
            </Reveal>
          ))}
        </div>
        {items.length === 0 && (
          <Reveal><p className="font-serif text-2xl text-white/40 mt-20">The first names will appear here soon.</p></Reveal>
        )}
        <Reveal>
          <div className="mt-24 border-t border-white/10 pt-10">
            <p className="text-white/50 max-w-lg">Own something from the universe and you become eligible to appear here — always your choice, never automatic.</p>
            <Link to="/store" className="inline-block mt-6 font-mono text-[11px] tracking-[0.25em] text-gold hover:text-white transition-colors">VISIT THE STORE →</Link>
          </div>
        </Reveal>
      </div>
    </div>
  );
}
